import { render, staticRenderFns } from "./ThemeBackgroundPane.vue?vue&type=template&id=643742ff&scoped=true"
import script from "./ThemeBackgroundPane.vue?vue&type=script&lang=js"
export * from "./ThemeBackgroundPane.vue?vue&type=script&lang=js"
import style0 from "./ThemeBackgroundPane.vue?vue&type=style&index=0&id=643742ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643742ff",
  null
  
)

export default component.exports